import type {AddComponentTypeOptions, ComponentDefinition} from 'grapesjs';
import {FORM_SIGNUP_FORM_STYLES} from '@FormMakerReact/components/component-styles';
import {POSTERMYWALL_FORM_BACKGROUND_TYPE} from '@FormMakerReact/components/postermywall-form-background/postermywall-form-background';
import {POSTERMYWALL_HEADING_TEXT_TYPE} from '@FormMakerReact/components/postermywall-heading-text/postermywall-heading-text';
import {POSTERMYWALL_DESCRIPTION_TEXT_TYPE} from '@FormMakerReact/components/postermywall-description-text/postermywall-description-text';
import {POSTERMYWALL_EMAIL_FORM_TYPE} from '@FormMakerReact/components/postermywall-email-form/postermywall-email-form';
import {POSTERMYWALL_EMAIL_BOX_TYPE} from '@FormMakerReact/components/postermywall-email-box/postermywall-email-box';
import {POSTERMYWALL_LABEL_TYPE} from '@FormMakerReact/components/postermywall-label/postermywall-label';
import {POSTERMYWALL_ERROR_MESSAGE_CONTAINER_TYPE} from '@FormMakerReact/components/postermywall-error-message-container/postermywall-error-message-container';
import {ICON_VECTOR_INLINE_ERROR_SVG, POSTERMYWALL_ICON_VECTOR_TYPE} from '@FormMakerReact/components/postermywall-icon-vector/postermywall-icon-vector';
import {POSTERMYWALL_ERROR_MESSAGE_TYPE} from '@FormMakerReact/components/postermywall-error-message/postermywall-error-message';
import {POSTERMYWALL_POLICY_TYPE} from '@FormMakerReact/components/postermywall-policy/postermywall-policy';
import {POSTERMYWALL_SUBMIT_BUTTON_TYPE} from '@FormMakerReact/components/postermywall-submit-button/postermywall-submit-button';
import {POSTERMYWALL_SUBMIT_BUTTON_CONTAINER_TYPE} from '@FormMakerReact/components/postermywall-submit-button-container/postermywall-submit-button-container';

export const POSTERMYWALL_SIGNUP_FORM_TYPE = 'postermywall-signup-form';
const DATA_ATTR = 'data-is-pmw-signup-form';
export function buildDefaultSignupFormChildren(): ComponentDefinition[] {
  return [
    {
      type: POSTERMYWALL_FORM_BACKGROUND_TYPE,
      components: [
        {type: POSTERMYWALL_HEADING_TEXT_TYPE},
        {type: POSTERMYWALL_DESCRIPTION_TEXT_TYPE},
        {
          type: POSTERMYWALL_EMAIL_FORM_TYPE,
          components: [
            {type: POSTERMYWALL_EMAIL_BOX_TYPE},
            {
              type: POSTERMYWALL_LABEL_TYPE,
              components: [
                {
                  type: POSTERMYWALL_ERROR_MESSAGE_CONTAINER_TYPE,
                  components: [{type: POSTERMYWALL_ICON_VECTOR_TYPE, content: ICON_VECTOR_INLINE_ERROR_SVG}, {type: POSTERMYWALL_ERROR_MESSAGE_TYPE}],
                },
              ],
            },
            {type: POSTERMYWALL_POLICY_TYPE},
            {type: POSTERMYWALL_SUBMIT_BUTTON_CONTAINER_TYPE, components: [{type: POSTERMYWALL_SUBMIT_BUTTON_TYPE}]},
          ],
        },
      ],
    },
  ];
}

export const POSTERMYWALL_SIGNUP_FORM: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'DIV' && el.getAttribute(DATA_ATTR) !== null ? {type: POSTERMYWALL_SIGNUP_FORM_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'div',
      toolbar: [],
      copyable: false,
      draggable: false,
      droppable: false,
      hoverable: false,
      selectable: false,
      highlightable: false,
      badgable: false,
      style: FORM_SIGNUP_FORM_STYLES,
      attributes: {
        [DATA_ATTR]: '1',
        id: POSTERMYWALL_SIGNUP_FORM_TYPE,
      },
    },
  },
};
